/**
 * Created with JetBrains WebStorm.
 * User: yujy
 * Date: 15-12-8
 * Time: 下午4:13
 * To change this template use File | Settings | File Templates.
 */
import fvSubassembly from "../fvSubassembly";
export default class fvTwobezierlineObj extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        this.createSucss();
    }

    onDraw(canvas){
        if(true) return;
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.beginPath();
        // canvas.moveTo(parseFloat(this.points[0][0]),parseFloat(this.points[0][1]));
        // console.log(this.encodeArray2D(this.points));
        var pointsStr = eval(""+this.encodeArray2D(this.points)+"");
        // canvas.bezierCurveTo(Number(this.encodeArray2D(this.points)));
        canvas.moveTo(20,20);
        // canvas.bezierCurveTo(pointsStr);
        // this.points.forEach(function(point,i) {
        //     if(this.points[i+1]){
        //         canvas.lineTo(parseFloat(this.points[i+1][0]),parseFloat(this.points[i+1][1]));
        //     }
        // }, this);
        canvas.strokeStyle = this.borderColor;
        canvas.stroke();
        canvas.globalCompositeOperation = 'source-over';
        this.Render();
        this.draw(canvas);
        this.isUpdataCache = false;
    }
    encodeArray2D(obj) {
        var array = [];
        for (var i = 0; i < obj.length; i++) {
          array[i] = obj[i].join(',');
        }
        return array.join(',').split(",").slice(2).join(',');
      }
}


// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvTwobezierlineObj.js